import { Div, Text } from "@tblabs/truffle";
import { Faq } from "../../../Models/Description/Faq/Faq";
import { Markdown } from "../../Utils/Markdown";


export class FaqPrinter extends Div
{
    constructor(faq: Faq)
    {
        super("product-questions__item");
        this.Append(
            new Div().Class("product-questions__box").Append(
                new Text(faq.Question).Class("product-questions__question"),
                new Markdown(faq.Answer).Class("product-questions__answer"),
            ),
            new Div().Class("product-questions__separator"),
        )
    }
}
